import qrcode from 'qrcode-generator';
import { useEffect, useRef, useState } from 'react';
import { useAvisoBreve } from '../componentes/avisoBreve';

/** Copia al portapapeles; sin portapapeles (navegador antiguo o sin permiso), falla. */
export async function copiarTexto(texto: string): Promise<void> {
    const portapapeles = navigator.clipboard as Clipboard | undefined;
    if (portapapeles === undefined) {
        throw new Error('Sin portapapeles');
    }
    await portapapeles.writeText(texto);
}

/** Copia y avisa (el aviso breve del panel); devuelve si se pudo. */
export function useCopiar(): (texto: string, aviso: string) => Promise<boolean> {
    const avisar = useAvisoBreve();
    return (texto, aviso) =>
        copiarTexto(texto)
            .then(() => {
                avisar({ tipo: 'ok', texto: aviso });
                return true;
            })
            .catch(() => {
                avisar({ tipo: 'error', texto: 'No se ha podido copiar. Mantén pulsado el texto para copiarlo.' });
                return false;
            });
}

/** «Hecho» durante 2 s tras copiar (RV Copiar: «Copiar mi enlace» → «Enlace copiado»). */
export function useHecho(): [boolean, () => void] {
    const [hecho, setHecho] = useState(false);
    const reloj = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
    useEffect(() => () => {
        clearTimeout(reloj.current);
    }, []);
    return [
        hecho,
        () => {
            clearTimeout(reloj.current);
            setHecho(true);
            reloj.current = setTimeout(() => {
                setHecho(false);
            }, 2000);
        },
    ];
}

/** Descarga el QR del enlace de alta como imagen SVG (para imprimirlo en presentaciones). */
export function descargarQr(texto: string, nombre: string): void {
    if (typeof URL.createObjectURL !== 'function') {
        return;
    }
    const qr = qrcode(0, 'M');
    qr.addData(texto);
    qr.make();
    const svg = qr.createSvgTag({ cellSize: 8, margin: 4, scalable: true });
    const enlace = document.createElement('a');
    enlace.href = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml' }));
    enlace.download = nombre;
    document.body.appendChild(enlace);
    enlace.click();
    enlace.remove();
    URL.revokeObjectURL(enlace.href);
}

